import { AnimatePresence, motion } from "framer-motion"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import {
    buildEmployeeMonthWorkSummaryText,
    calculateEmployeeMonthWorkSummary
} from "../../../utils/employeeMonthWorkSummary"

const SUMMARY_MOTION = {
    initial: { scale: 0.4, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.4, opacity: 0 },
    transition: { duration: 0.14, delay: 0.14 }
}

const EmployeeMonthWorkSummary = ({ logsByDay, year, monthIndex, isDarkTheme, loading }) => {
    const { i18n } = useTranslation("stats")
    const showContent = !loading && logsByDay != null
    const text = useMemo(() => {
        if (!showContent) return null
        const summary = calculateEmployeeMonthWorkSummary(logsByDay, year, monthIndex)
        return buildEmployeeMonthWorkSummaryText(summary)
    }, [showContent, logsByDay, year, monthIndex, i18n.language])

    const hasDetails = Boolean(text?.detailLines.length)

    return (
        <div
            className={`asv-employee-month-work-summary${hasDetails ? " asv-employee-month-work-summary--has-details" : ""}${isDarkTheme ? " asv-employee-month-work-summary--dark" : ""}`}
        >
            <AnimatePresence mode="wait" initial={false}>
                {text ? (
                    <motion.div
                        key={`${year}-${monthIndex}`}
                        className="asv-employee-month-work-summary-motion"
                        initial={SUMMARY_MOTION.initial}
                        animate={SUMMARY_MOTION.animate}
                        exit={SUMMARY_MOTION.exit}
                        transition={SUMMARY_MOTION.transition}
                        style={{ transformOrigin: "left center" }}
                    >
                        <p
                            className={`asv-employee-month-work-summary-short asv-employee-month-work-summary-short--${text.status} ${isDarkTheme ? "dark-color" : ""}`}
                        >
                            {text.shortLine}
                        </p>
                        {hasDetails ? (
                            <div
                                className={`asv-employee-month-work-summary-details${isDarkTheme ? " asv-employee-month-work-summary-details--dark" : ""}`}
                                role="tooltip"
                            >
                                {text.detailLines.map((line) => (
                                    <p key={line} className="asv-employee-month-work-summary-details-line">
                                        {line}
                                    </p>
                                ))}
                            </div>
                        ) : null}
                    </motion.div>
                ) : null}
            </AnimatePresence>
        </div>
    )
}

export default EmployeeMonthWorkSummary
